import axios from 'axios'
import load from "@/LOAD.js";
import store from "@/store/index.js"
import storage from "@/services/storage.js"

const instance = axios.create({
  baseURL: load.getUrlApi(),
})



// ------- Request interceptor ------
instance.interceptors.request.use(config => {

  // Controllo se avviare l'attesa
  if (config.noLoadingBar === undefined || config.noLoadingBar == false)
    store.commit('app/SET_LOADING', true) // Avvio attesa


  // Imposto il token
  if (store.getters['auth/isAuthenticated'])
    config.headers.Authorization = storage.getAuthHeader()

  return config

}, function (error) {

  // Fine attesa
  store.commit('app/SET_LOADING', false)

  return Promise.reject(error)
})


// ------- Response interceptor ------
instance.interceptors.response.use((response) => {

  // Fine attesa
  store.commit('app/SET_LOADING', false)

  return response

}, async function (error) {

  // Fine attesa
  store.commit('app/SET_LOADING', false)

  let originalRequest = error.config

  // Controllo scadenza token
  if (error.response && error.response.status === 401 && !originalRequest._retry) {

    originalRequest._retry = true

    // Controllo ricorda
    //if (storage.checkRemember()) {

    // Login con refreshToken
    return store.dispatch("auth/refreshToken").then(authResponse => {

        instance.defaults.headers.common['Authorization'] = 'Bearer ' + authResponse.data.access_token;
        originalRequest.headers['Authorization'] = 'Bearer ' + authResponse.data.access_token

        return instance(originalRequest)

      })
      .catch(err => {
        console.log(err)

        // Ritorno al login
        // NOTA: se il token non è stato rinnovato dal refresh token, non posso fare la dispatch per registrare il logout,
        //       ma devo uscire per forza
        storage.logout()

      });
    // Login con refreshToken
    /* try {
      const authResponse = await store.dispatch("auth/refreshToken");
      instance.defaults.headers.common['Authorization'] = 'Bearer ' + authResponse.data.access_token;
      originalRequest.headers['Authorization'] = 'Bearer ' + authResponse.data.access_token;
      return await instance(originalRequest);
    } catch (err) {
      console.log(error);

      // Ritorno al login
      // NOTA: se il token non è stato rinnovato dal refresh token, non posso fare la dispatch per registrare il logout,
      //       ma devo uscire per forza
      storage.logout();
    } */


    //}

    // Ritorno al login
    // NOTA: se il token è scaduto non posso fare la dispatch per registrare il logout, ma devo uscire per forza
    //storage.logout()

  }

  // Fine attesa
  store.commit('app/SET_LOADING', false)

  console.log("interceptor response " + error)

  return Promise.reject(error);

})

export default instance